export default __webpack_public_path__ + "static/media/240424_Schildershop_Illu_XS.8e2bf322.webp";